import { useState } from "react";
import type { Page } from "./types";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { TargetAudience } from "./components/TargetAudience";
import { BeforeAfter } from "./components/BeforeAfter";
import { Benefits } from "./components/Benefits";
import { Pillars } from "./components/Pillars";
import { Features } from "./components/Features";
import { Showcase } from "./components/Showcase";
import { Steps } from "./components/Steps";
import { Pricing } from "./components/Pricing";
import { Comparison } from "./components/Comparison";
import { FAQ } from "./components/FAQ";
import { FinalCTA } from "./components/FinalCTA";
import { ContactForm } from "./components/ContactForm";
import { Footer } from "./components/Footer";

export default function App() {
    const [page, setPage] = useState<Page>("home");

    const navigate = (p: Page) => {
        setPage(p);
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <>
            <Navbar onNavigate={navigate} />
            {page === "contact" ? (
                <main>
                    <ContactForm onNavigate={navigate} />
                </main>
            ) : (
                <main>
                    <Hero onNavigate={navigate} />
                    <TargetAudience />
                    <BeforeAfter />
                    <Benefits />
                    <Pillars />
                    <Showcase />
                    <Features />
                    <Steps />
                    <Pricing onNavigate={navigate} />
                    <Comparison />
                    <FAQ />
                    <FinalCTA onNavigate={navigate} />
                </main>
            )}
            <Footer onNavigate={navigate} />
        </>
    );
}
